<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Liste</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Permissions</h3>
            </div>
            <div class="col-6 text-right">
              <base-button type="primary" icon size="sm" @click="addPermission()">
                <span class="btn-inner--icon"
                  ><i class="fas fa-user-edit"></i
                ></span>
                <span class="btn-inner--text">Ajouter Permission</span>
              </base-button>
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Par page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <div>
              <base-input
                v-model="query"
                type="search"
                prepend-icon="fas fa-search"
                placeholder="Rechercher..."
                clearable
              />
            </div>
          </div>
          <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="mapPermissions"
            @sort-change="sortChange"
          >
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>
            <el-table-column label="Nom" prop="name" sortable="custom" />

            <el-table-column
              label="Rôles"
              min-width="130px"
              max-width="400px"
              prop="tags.name"
              sortable="custom"
            >
              <template slot-scope="{ row }">
                <span
                  v-for="(role, index) in row.roles"
                  :key="'role' + index"
                  class="badge badge-default"
                  :style="{ backgroundColor: role.color, margin: '.1rem' }"
                  >{{ role.name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="Crée le"
              prop="created_at"
              sortable="custom"
            />
            <el-table-column align="center">
              <div slot-scope="{ row }" class="table-actions">
                <el-tooltip content="Modifier" placement="top">
                  <a
                    type="text"
                    @click="editPermission(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-user-edit" />
                  </a>
                </el-tooltip>

                <el-tooltip content="Supprimer" placement="top">
                  <a
                    type="text"
                    @click="deletePermission(row.id)"
                    class="table-action table-action-delete"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-trash" />
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              Affichage de {{ total ? from + 1 : 0 }} à {{ to }} sur
              {{ total }} Permissions

              <span v-if="selectedRows.length">
                &nbsp; &nbsp; {{ selectedRows.length }} lignes sélectionnées
              </span>
            </p>
</div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          />
        </div>
      </card>
    </div>
  </div>
  </div>
</template>
<script>
import moment from 'moment'
moment.locale('fr');

import { BasePagination } from "@/components/";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  layout: "DashboardLayout",

  components: {
    BasePagination,
    RouteBreadCrumb,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  data() {
    return {
      permissions: [],
      selectedRows: [],
      query: null,
      sort: "created_at",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
      },

      total: 0,
      loading: true,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    mapPermissions() {
      if (this.permissions){
        let items = this.permissions
        items.map( item => {
          return item.created_at = moment(new Date(item.created_at).getTime()).fromNow()
          }
        )
        return items
      }
      else
        return []
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
          ...(this.query ? { name: this.query } : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };
      await this.$store.dispatch("permissions/list", params);
      this.permissions = this.$store.getters["permissions/list"];
      this.total = this.$store.getters["permissions/listTotal"];
      this.loading = false;
    },

    async deletePermission(id) {
      const confirmation = await swal.fire({
        title: `Supprimer cette Permission?`,
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Oui, la supprimer!",
        cancelButtonText: "Non, la garder",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("permissions/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Permission supprimée avec succès.",
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: "Cette Permission est toujours associée à un utilisateur.",
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Désolé, une erreur est survenue lors de la requête!",
          });
        }
      }
    },
    addPermission() {
      this.$router.push({ name: "Ajouter Permission" });
    },
    editPermission(row) {
      this.$router.push({
        name: "Modifier Permission",
        params: { id: row.id },
      });
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
